import React from "react";
import { resolvePostLoginRoute } from '../auth/pcAuthBrowserFlow';

const Callback = (props) => {
    return (
        <div>
            {props.history.push(resolvePostLoginRoute())}
        </div>
    );
}; export default Callback
